// Keeps the back-in-stock form (snippets/back-in-stock-form.liquid) in step
// with the variant picker: shown only for a sold-out variant, with the
// "<productId>-<variantId>" tag the Messaging back-in-stock Flow looks for
// and the variant's name in the intro line.
if (!customElements.get('back-in-stock-form')) {
  customElements.define(
    'back-in-stock-form',
    class BackInStockForm extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.tagInput = this.querySelector('input[name="contact[tags]"]');
        this.variantName = this.querySelector('[data-bis-variant]');
        this.consent = this.querySelector('[data-bis-consent]');

        // Replace the browser's "Please tick this box" with friendlier wording.
        if (this.consent) {
          this.consent.addEventListener('invalid', () =>
            this.consent.setCustomValidity('Tick the box so we can email you when it’s back.')
          );
          this.consent.addEventListener('change', () => this.consent.setCustomValidity(''));
        }

        // Hide while the next variant loads; an option combination that
        // doesn't exist never publishes variantChange, so it stays hidden.
        this.unsubscribers = [
          subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => this.classList.add('hidden')),
          subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (this.productInfo && data.sectionId !== this.productInfo.sectionId) return;
            this.update(data.variant);
          }),
        ];
      }

      disconnectedCallback() {
        this.unsubscribers?.forEach((unsubscribe) => unsubscribe());
      }

      update(variant) {
        const soldOut = Boolean(variant) && !variant.available;
        this.classList.toggle('hidden', !soldOut);
        if (!soldOut) return;

        if (this.tagInput) this.tagInput.value = `back-in-stock,${this.dataset.productId}-${variant.id}`;
        if (this.variantName && this.dataset.singleVariant !== 'true') this.variantName.textContent = variant.title;
      }
    }
  );
}
